export default "__VITE_ASSET__Dwnb830i__"